import { render, staticRenderFns } from "./user-profile-delete-account-tab.vue?vue&type=template&id=ef623fb6&scoped=true&"
import script from "./user-profile-delete-account-tab.vue?vue&type=script&lang=js&"
export * from "./user-profile-delete-account-tab.vue?vue&type=script&lang=js&"
import style0 from "./user-profile-delete-account-tab.vue?vue&type=style&index=0&id=ef623fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef623fb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VTextField})
